export { default } from './SlashScreen'
